export enum ExportFields {
  VENUE_FORM = 'venue',
  LABEL_FORM = 'label',
  CUSTOMER_GROUP_FORM = 'customerGroup',
  FLAVOR_FORM = 'flavor',
}
